module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "version": "1.1",
      "viewBox": "0 0 348.33 348.33",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "enable-background": "new 0 0 348.333 348.334"
    }
  }, [_c('path', {
    attrs: {
      "d": "m336.56 68.611-105.54 105.55 105.54 105.55c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769l-105.57-105.56-105.56 105.56c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.55-105.55-105.55c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.56 105.55 105.56-105.55c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145 6e-3 56.844z",
      "fill": "currentColor"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e380fc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/icons/Close3.vue
// module id = 218
// module chunks = 0 1